import { useResetVirtualizationCache } from './useResetVirtualizationCache';
import { createContext, CSSProperties, forwardRef, ReactNode, useContext } from 'react';
import { VariableSizeList } from 'react-window';

const OuterElementContext = createContext({});
const ListBoxWrapper = forwardRef<HTMLDivElement, any>(function ListBoxWrapper(props, ref) {
  const outerProps = useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function RenderRow({ data, index, style }: { data: ReactNode[]; index: number; style: CSSProperties }) {
  return <li style={style}>{data[index]}</li>;
}

export const VirtualizedListBox = forwardRef<
  HTMLDivElement,
  {
    children: ReactNode[];
    [key: string]: any;
  }
>(function VirtualizedListBox(listboxProps, ref) {
  const { children, ...otherListBoxProps } = listboxProps;
  const itemCount = children.length;
  const refVirtualizedList = useResetVirtualizationCache(itemCount);
  const OPTION_HEIGHT = 48;

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={otherListBoxProps}>
        <VariableSizeList
          ref={refVirtualizedList}
          itemData={children}
          itemCount={itemCount}
          itemSize={() => OPTION_HEIGHT}
          height={Math.min(OPTION_HEIGHT * itemCount, 448)}
          width="100%"
          outerElementType={ListBoxWrapper}
          innerElementType="ul"
          overscanCount={5}
        >
          {RenderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});
